import { Loader2 } from 'lucide-react';

export const Spinner = ({ className = '', size = 24 }: { className?: string; size?: number }) => (
  <Loader2 size={size} className={`animate-spin text-primary ${className}`} />
);
